import TomSelect from "tom-select";
import {artistConfig, config, tagConfig} from "./config";
import {getArtist, getArtistsByName} from "../helpers/ArtistApi";
import { getTagsByName } from "../helpers/TagApi";
import {getAlbum, getAlbumsByName} from "../helpers/AlbumApi";

const artistLoadHandler = function(query, callback) {
	const self = this;
	if( self.loading > 1 ){
		callback();
		return;
	}

	getArtistsByName(encodeURIComponent(query))
		.then(res => res.data)
		.then(json => {
			callback(json)
		}).catch((err) => {
		console.log('Error', err);
	});
}

const albumLoadHandler = function(query, callback) {
	const self = this;
	if( self.loading > 1 ){
		callback();
		return;
	}

	const artist = document.querySelector('[name="fk_artist"]');

	getAlbumsByName(encodeURIComponent(query), artist ? artist.value : null)
		.then(res => res.data)
		.then(json => {
			callback(json)
		}).catch((err) => {
		console.log('Error', err);
	});
}

export function initializeArtistSelects() {
	const artistSelects = document.querySelectorAll('[data-select-entity="artist"]');
	artistSelects.forEach(select => {
		const control = new TomSelect(select, {
			...artistConfig, ...{
				load: artistLoadHandler
			}
		});

		const defaultDataValue = select.dataset.value;

		if (defaultDataValue) {
			const defaultValues = JSON.parse(select.dataset.value);

			defaultValues.forEach(defaultValue => {
				getArtist(defaultValue).then(res => {
					control.addOption({
						id: res.data.id,
						image: res.data.image,
						name: res.data.name
					}, false);

					control.addItem(res.data.id);
				});
			})
		};

		control.on('change', () => {
			control.close()
		});
	});
}

export function initializeAlbumSelects() {
	const artistSelects = document.querySelectorAll('[data-select-entity="album"]');

	artistSelects.forEach(select => {
		const control = new TomSelect(select, {
			...config, ...{
				load: albumLoadHandler
			}
		});

		const defaultDataValue = select.dataset.value;

		if (defaultDataValue) {
			const defaultValues = JSON.parse(select.dataset.value);

			defaultValues.forEach(defaultValue => {
				getAlbum(defaultValue).then(res => {
					control.addOption({
						id: res.data.id,
						image: res.data.image,
						name: res.data.name
					}, false);

					control.addItem(res.data.id);
				});
			})
		};

		control.on('change', () => {
			control.close()
		});
	});
}

const tagLoadHandler = function(query, callback) {
	const self = this;
	if( self.loading > 1 ){
		callback();
		return;
	}

	getTagsByName(encodeURIComponent(query))
		.then(res => res.data)
		.then(json => {
			callback(json)
		}).catch((err) => {
		console.log('Error', err);
	});
}

export function initializeTagSelects() {
	const tagSelects = document.querySelectorAll('[data-select-entity="tag"]');
	tagSelects.forEach(select => {
		const control = new TomSelect(select, {
			...tagConfig, ...{
				load: tagLoadHandler
			}
		});

		control.on('change', () => control.close());
	});
}
